import { useRouter } from 'next/router'

import { Breakpoint, useCheckBreakpoint } from '~/utils'
import ChatAiOpenButton from '~/aioracle/ChatAiOpenButton'
import useDeclareOracleAvailability from '~/aioracle/hooks/useDeclareOracleAvailability'
import isOracleAvailableOnPath from '~/aioracle/utils/isOracleAvailableOnPath.utils'

// The panel is mounted once in _app; a layout declares availability and owns the desktop button.
const LayoutChatButton = ({
  hideBottomMenu,
  hideChatButton,
}: {
  hideBottomMenu?: boolean
  hideChatButton?: boolean
}): React.ReactElement => {
  const { asPath } = useRouter()
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isAvailable = isOracleAvailableOnPath(asPath)

  useDeclareOracleAvailability({ isAvailable, hideBottomMenu: !!hideBottomMenu })

  return isAvailable && !(hideChatButton || isMobile) ? <ChatAiOpenButton isMobile={false} /> : <></>
}

export default LayoutChatButton
